import React, { Component } from 'react'
import classnames from 'classnames'
import InputGroup from '../inputs/InputGroup'
import Select from 'react-select'
import defaultSelectTheme from './styles/defaultSelectTheme'

const themeProps = {
  default: defaultSelectTheme
}

class SelectInput extends Component {
  constructor(props) {
    super(props)
    this.renderComponent = this.renderComponent.bind(this)
  }

  renderComponent(forwardedProps) {
    const { theme } = this.props
    const prefix = 'react-select';
    const selectClasses = classnames(prefix, `${prefix}--${theme}`);

    return (
      <Select
        className={selectClasses}
        classNamePrefix={prefix}
        styles={themeProps[theme]}
        {...forwardedProps}
      />
    )
  }

  render() {
    const { theme, ...props } = this.props
    return ( <InputGroup {...props} Component={this.renderComponent} /> );
  }
};

SelectInput.defaultProps = {
  theme: "default"
}

export default SelectInput
